import React from 'react';
import { ExternalLink, Youtube } from 'lucide-react';
import { Link } from 'react-router';
import { getContentFor } from '../data/verseDeliveryContent';
import peacefulBackground from '../assets/peaceful-river-video-background.png';
import ScreenLayout from './ScreenLayout';

const getPlaylistUrl = () => {
    const configured = process.env.REACT_APP_YOUTUBE_PLAYLIST_URL?.trim();
    if (!configured) return '';

    try {
        const url = new URL(configured);
        return url.protocol === 'https:' ? url.toString() : '';
    } catch {
        return '';
    }
};

export default function VerseStudio() {
    const item = getContentFor('anxious', 0);
    const playlistUrl = getPlaylistUrl();

    return (
        <ScreenLayout
            title="Verse Studio"
            icon={Youtube}
            eyebrow="Curated Scripture"
            className="detail-studio"
            actions={<Link className="module-text-control" to="/devotionals">Today’s devotional</Link>}
        >
            <div className="vd-studio">
                <header className="detail-heading">
                    <p className="detail-date">Curated Scripture — never AI-written</p>
                    <h1>A quiet verse for right now.</h1>
                </header>

                <div className="vd-video-stage" aria-label="Curated verse artwork">
                    <img src={peacefulBackground} alt="Sunrise over a peaceful river valley" />
                    <div>
                        <blockquote>“{item.text}”</blockquote>
                        <cite>{item.reference}</cite>
                    </div>
                </div>

                <section>
                    <div>
                        <h2>Daily Verse Video Playlist</h2>
                        <p>
                            {playlistUrl
                                ? 'Open the connected playlist for captioned Scripture and read-aloud verse videos.'
                                : 'The video playlist isn’t available yet. You can still read today’s devotional and Scripture.'}
                        </p>
                    </div>
                    {playlistUrl ? (
                        <a href={playlistUrl} target="_blank" rel="noreferrer">
                            <Youtube size={20} /> Open YouTube playlist <ExternalLink size={15} />
                        </a>
                    ) : (
                        <Link to="/devotionals">Open today’s devotional</Link>
                    )}
                </section>
            </div>
        </ScreenLayout>
    );
}
